import { render, staticRenderFns } from "./wangeditor.vue?vue&type=template&id=057219b6&scoped=true"
import script from "./wangeditor.vue?vue&type=script&lang=js"
export * from "./wangeditor.vue?vue&type=script&lang=js"
import style0 from "./wangeditor.vue?vue&type=style&index=0&id=057219b6&prod&lang=scss&scoped=true"
import style1 from "./wangeditor.vue?vue&type=style&index=1&id=057219b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057219b6",
  null
  
)

export default component.exports